import { CSSProperties, FC, useEffect, useState } from 'react';
import styles from './HideSensitiveDataButton.module.scss';
import { withStyles, MaterialSymbol } from 'vopay';

const cn = withStyles(styles);

type HideSensitiveDataButtonProps = { content: string | number; color?: CSSProperties['color'] };

const PULSE_DURATION_MS = 200;

const HideSensitiveDataButton: FC<HideSensitiveDataButtonProps> = ({ content, color = 'hsla(216, 100%, 59%, 1)' }) => {
  const [animating, setAnimating] = useState(false);
  const [showData, setShowData] = useState(false);
  const hiddenPlaceholder = '**********';

  useEffect(() => {
    if (animating) {
      const timeout = setTimeout(() => {
        setAnimating(false);
      }, PULSE_DURATION_MS);

      return () => clearTimeout(timeout);
    }
    return () => {};
  }, [animating]);

  return (
    <span className={cn('hideSensitiveDataButton')}>
      {showData ? content : hiddenPlaceholder}
      <button
        type="button"
        style={{
          '--duration': `${PULSE_DURATION_MS}ms`,
        }}
        className={cn('copyButton', animating && 'animating')}
        onClick={() => {
          setAnimating(true);
          setShowData((prev) => !prev);
        }}
      >
        <MaterialSymbol
          icon={showData ? 'visibility_off' : 'visibility'}
          size="24px"
          color={color}
          className={cn('icon')}
        />
      </button>
    </span>
  );
};

export default HideSensitiveDataButton;
